<template>
  <div class="app-page">
    <section class="about-section front-page-section">
      <div class="front-page-section__content">
        <div class="landing-section__mission">
          <p>
            “AUGam” ir nevalstiska organizācija, kas veicina augu valsts uztura
            izplatību, pieejamību un ilgtspēju.
          </p>
          <br />
          <p>“AUGam”:</p>
          <ul>
            <li>
              rosina Latvijas iedzīvotājus izvēlēties augu valsts uzturu,
              sniedzot informāciju, motivāciju, atbalstu un praktisku palīdzību;
            </li>
            <li>
              rīko informatīvus un izzinošus pasākumus, piemēram, augu valsts
              ēdiena svētkus;
            </li>
            <li>
              sadarbojas ar pārtikas nozares uzņēmumiem un valsts iestādēm, lai
              palielinātu augu valsts uztura daudzveidību un pieejamību.
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="members-section front-page-section">
      <div class="front-page-section__content">
        <h1>Ēdiena svētku organizatoriskā komanda</h1>
        <div class="member-container">
          <Members
            v-for="member in foodMemberData"
            :key="member.id"
            :name="member.name"
            :image="member.image"
            :description="member.description"
            :email="member.email"
          >
          </Members>
        </div>
        <div class="member-container-second">
          <h1>Pārējā "AUGam" komanda</h1>
          <div class="member-container">
            <Members
              v-for="member in otherMemberData"
              :key="member.id"
              :name="member.name"
              :image="member.image"
              :description="member.description"
              :email="member.email"
            >
            </Members>
          </div>
        </div>
      </div>
    </section>
    <section class="contacts-section front-page-section">
      <div class="front-page-section__content">
        <div class="contact-container">
          <div class="contact-info">
            <h3>Kontaktinformācija</h3>
            <div>
              <span class="contact-key">E-pasts: </span
              ><span class="contact-value">info@augam.lv</span>
              <!--<p><span><br/>Individuālie epasti spiežot uz portretiem</span></p>-->
            </div>
          </div>
          <div class="bank-info">
            <h3>Rekvizīti</h3>
            <div>
              <P><span class="contact-value">Biedrība "AUGam"</span></P>
              <p>
                <span class="contact-key">Reģ. Nr.: </span
                ><span class="contact-value">40008274777</span>
              </p>
              <p>
                <span class="contact-key">Konts: </span
                ><span class="contact-value">LV10HABA0551046531901</span>
              </p>
              <p>
                <span class="contact-key">Banka: </span
                ><span class="contact-value">Swedbank</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Members from "../components/Members";
//    import Box from "../components/Box.vue"

export default {
  name: "about",
  components: {
    Members,
    //            Box
  },
  data: () => ({
    foodMemberData: [
      {
        name: "Ketlīna Kļaviņa",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/members%2FKETLINA.jpg?alt=media&token=730769e5-e24f-471e-8573-8b5444ca7579",
        description: "vadība un ēdinātāju koordinēšana",
        email: "ketlina.klavina@augam.lv",
      },
      {
        name: "Ieva Immure",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/members%2Fieva_i.jpg?alt=media&token=cb60f2f8-7dcc-4a95-8167-84d4cab37806",
        description:
          "vizuālā identitāte, sociālie tīkli, sabiedriskās attiecības",
        email: "ieva.immure@augam.lv",
      },
      {
        name: "Dāvis Immurs",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/members%2Fdavis.jpg?alt=media&token=7a92af10-1cdf-4af3-b00d-1bf74a14c68c",
        description: "tehniskie risinājumi",
        email: "davis.immurs@augam.lv",
      },
      {
        name: "Marta Turkopule",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/members%2FMARTA.jpg?alt=media&token=3f3568bc-e66f-42e5-b724-8f920e61f4d9",
        description: "sadarbība ar atbalstītājiem",
        email: "marta.turkopule@augam.lv",
      },
      {
        name: "Laima Vasile",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/members%2Flaima.jpg?alt=media&token=3393d28b-f471-4c8d-aa0d-01e06e8e18f7",
        description: "sadarbība ar atbalstītājiem",
        email: "laima.vasile@augam.lv",
      },
    ],
    otherMemberData: [
      {
        name: "Līva Siliņa",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/liva.png?alt=media&token=d277bb96-1b27-4df1-8e3a-0dbd1327c4c5",
        description: "projektu vadība",
        email: "liva.silina@augam.lv",
      },
      {
        name: "Edgars Anspoks",
        image:
          "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/edgars.png?alt=media&token=e2ddf422-30a3-457b-88ab-e10fee1ddbf2",
        description: "vietnes izstrāde, IT",
        email: "edgars.anspoks@augam.lv",
      },
      // {
      //     name: "Ieva Gedzuna",
      //     image: "https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/users%2Fgedzuna%40gmail.com%2Fxn0kmf0.jpg?alt=media&token=c49c8818-db37-400a-8f2d-14ecdf672728",
      //     description: "blogs",
      //     email: "ieva.gedzuna@augam.lv"
      // },
    ],
  }),
};
</script>

<style scoped>
.box-container {
  display: flex;
  flex-direction: column;
}

.about-section {
  opacity: 1;
  align-items: flex-end;
  /*clip-path: polygon( 0 0, 100% 0, 100% calc(100% - 5vw), 0 100% );*/
}
.about-section ul {
  margin-left: 60px;
}
.about-section .front-page-section__content {
  margin: 120px 35px 0;
}

.about-section::before {
  z-index: 100;
  content: "";
  opacity: 0.8;
  top: 0;
  right: 0;
  bottom: 0;
  left: -200px;
  position: absolute;
  /*background: url(../assets/img/green.jpg);*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
.approach-section {
  margin-top: -5vw;
}
.approach-section .front-page-section__content {
  border-bottom: 1px solid #464646;
  margin-top: 5vw;
}
.approach-section__methods {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  flex-wrap: wrap;
}

.approach-section__method-item {
  width: 150px;
  height: 170px;
  display: inline-block;
  font-weight: 600;
  color: inherit;
  font-size: 16px;
  text-align: center;
}

.approach-section__method-item .fa-seedling {
  font-size: 60px;
  color: rgba(121, 198, 22, 0.62);
}

.front-page-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 16px;
  color: #404040;
  position: relative;
}

.front-page-section__content {
  max-width: 720px;
  display: inherit;
  flex-direction: column;
  margin: 0 35px 0;
  text-align: start;
  z-index: 200;
  align-items: center;
}

.front-page-section__content h1 {
  margin: 0 0 20px 0;
  text-align: center;
}
.members-section .front-page-section__content {
  margin: 120px 0 0;
}
.member-container {
  display: flex;
  flex-direction: row;
  text-align: center;
  margin: 15px;
  flex-wrap: wrap;
  justify-content: center;
}
.member-container-second {
  margin-top: 45px;
}
.contact-container {
  display: flex;
  flex-direction: column !important;
  flex-flow: wrap;
  margin: 120px 0 60px;
}
.contact-container span {
  font-size: 16px;
}
.contact-info {
  margin: 0 15px 15px;
  flex: 1;
}
.bank-info {
  margin: 0 15px 15px;
  flex: 1;
}
.contact-key {
  font-weight: bold;
}
.contact-value {
  font-style: italic;
}
</style>
